var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 41.5047,
    height: 40,
    rx: 15,
    fill: "#9983FC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6533 26.4999C19.2065 26.4857 18.2705 26.11 18.2598 26.0927C16.7408 25.4785 13.8107 23.6243 12.457 22.3027L12.0635 21.9062C11.9606 21.7987 11.8443 21.6714 11.7725 21.5722C11.5325 21.266 11.4131 20.8866 11.4131 20.5078C11.4131 20.0849 11.5473 19.6916 11.8018 19.3701L12.2061 18.9492L12.2969 18.8593C13.5252 17.576 16.7318 15.478 18.4092 14.8359L18.6621 14.7421C18.9669 14.6368 19.3944 14.5115 19.6533 14.4999C19.9827 14.5 20.2977 14.5733 20.5977 14.7187C20.9723 14.9225 21.2703 15.2451 21.4355 15.624C21.5405 15.8856 21.7051 16.6685 21.7061 16.6874C21.8576 17.4816 21.9464 18.7351 21.959 20.1396L21.96 20.4931C21.96 21.9647 21.871 23.307 21.7363 24.1816L21.6182 24.7255C21.5525 25.0135 21.4659 25.3414 21.376 25.5087C21.0466 26.1211 20.4022 26.4999 19.7129 26.4999H19.6533ZM24.6914 21.6913C24.0158 21.6912 23.4678 21.1575 23.4678 20.4999C23.468 19.8415 24.0159 19.3096 24.6914 19.3095L28.5303 18.9824C29.3914 18.9825 30.0896 19.662 30.0898 20.4999C30.0898 21.3381 29.3916 22.0184 28.5303 22.0185L24.6914 21.6913Z",
    fill: "#9983FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.79515a44684910d04e26a6e004115029.svg";
export { ForwardRef as ReactComponent };